<template>
  <CountryPage country="sri_lanka" />
</template>